module.exports = __webpack_public_path__ + "img/trade.53857d78.png";